module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-es-a517cb5eecaa00032b18e030d3daf58c.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/app-store-badges/google-play-store-es.svg
// module id = +orn
// module chunks = 24